export { default } from './CurieAISidebar';
